import * as React from 'react'
import axios from 'axios'
import { quoteRequestBody } from './useCheckoutQuote'

// Asks Chargebee about a coupon (a quote with it) before the page adopts it,
// so a refused code never becomes part of the order: the price, the wallet
// buttons and the payment intent keep the last accepted coupon, and only the
// field shows the refusal. `check` resolves to the accepted quote, or null.
export function useCouponCheck() {
    const [state, setState] = React.useState({ checking: false, error: null })
    const sequenceRef = React.useRef(0)

    const check = React.useCallback(
        async inputs => {
            const sequence = ++sequenceRef.current
            setState({ checking: true, error: null })
            try {
                const response = await axios.post(
                    '/billing/quote',
                    quoteRequestBody(inputs)
                )
                if (sequence !== sequenceRef.current) return null
                setState({ checking: false, error: null })
                return response.data
            } catch (error) {
                if (sequence !== sequenceRef.current) return null
                setState({ checking: false, error })
                return null
            }
        },
        []
    )

    // Editing the code abandons a check still in flight and its refusal.
    const reset = React.useCallback(() => {
        sequenceRef.current += 1
        setState({ checking: false, error: null })
    }, [])

    return { ...state, check, reset }
}
